import { useQuery } from "react-query";
import { getAccountWarnings } from "../../../api/services/accounts/warnings";

export const useAccountWarnings = (accountNumber: string) => {
  return useQuery(["accounts/warnings", accountNumber], getAccountWarnings, {
    enabled: !!accountNumber,
  });
};
